import { Link, useLocation } from "react-router-dom";
import { FilePlus, Users } from "../../assets/icons/icons";
import styles from '../menu/style.module.css'

import { toast, ToastContainer } from 'react-toastify';

import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { authApi } from "../../services/api/api";
import { useState } from "react";
import useAuth from "../../hooks/useAuth";
import { BookCheck, BookPlus, BookText, Calendar, ChevronRight, NotebookPen, UsersRound } from "lucide-react";
import Book from "../book";

export default function MenuAdmin({ closeMenu }) {

    const { user, setUser } = useAuth()

    const api = authApi()

    const { pathname } = useLocation()

    const [open, setOpen] = useState(false);

    const [start, setStart] = useState(user?.start ?? '');

    const [end, setEnd] = useState(user?.end ?? '');

    const handleClickOpen = (e) => {
        e.stopPropagation();

        // Tira o foco do botão atual para evitar o erro de aria-hidden
        if (e.currentTarget) {
            e.currentTarget.blur();
        }

        setOpen(true);
        // if (closeMenu) closeMenu();
    };
    const handleClose = () => {
        setOpen(false);
        if (closeMenu) closeMenu();
    };

    async function handlefreePosts() {

        if (!start || !end) {
            toast.error('Preencha as datas!');
            return;
        }

        try {
            const payload = {
                start: String(start),
                end: String(end)
            };


            const response = await api.liberarPosts(payload);

            // console.log("Resposta da API recebida:", response);

            if (response?.id || response?.status === 200 || response === 200) {
                toast.success('Cronograma atualizado!', { theme: 'dark' });
                if (user && setUser) {
                    setUser({ ...user, start, end });
                }
                setOpen(false);
                setStart('');
                setEnd('');
            }
        } catch (error) {
            console.error("Erro no envio:", error);
        }
    }

    return (
        <div>
            <div className="flex flex-col gap-1">
                {/* Label da Seção */}
                <div className="px-4 py-2 mt-2">
                    <p className="text-[9px] uppercase font-bold tracking-[0.2em] text-gray-500">
                        Painel Administrativo
                    </p>
                </div>

                {/* Links do Menu */}
                {[
                    { name: 'Usuários', path: '/usuarios', icon: <UsersRound size={17} /> },
                    // { name: 'Adicionar Livro', path: '/adicionar-livro', icon: FilePlus },
                    { name: 'Gestão de Livros', path: '/gestao-de-livros', icon: <BookText size={17} /> },
                ].map((item) => (
                    <Link
                        key={item.path}
                        to={item.path}
                        onClick={() => closeMenu && closeMenu()}
                        className={`flex items-center gap-3 px-4 py-3 rounded-2xl transition-all group relative ${pathname === item.path
                                ? ' text-blue-600'
                                : 'text-slate-500 dark:text-slate-300 group-hover:text-blue5'
                            }`}
                    >
                        {/* Ícone Principal */}
                        <div className={`flex items-center  justify-center transition-colors ${pathname === item.path ? 'text-blue-600' : 'group-hover:text-blue5 text-slate-500'
                            }`}>
                            {item.icon}
                        </div>

                        {/* Nome do Item - Alinhado à esquerda com text-sm */}
                        <span className="text-sm font-medium tracking-tight flex-1 text-left group-hover:text-blue5">
                            {item.name}
                        </span>

                        {/* Chevron (Setinha) - Alinhado à direita através do flex-1 no span anterior */}
                        <div className={`flex items-center justify-center transition-all duration-300 ${pathname === item.path
                                ? 'opacity-100 translate-x-0 text-blue-600'
                                : 'opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 text-slate-300'
                            }`}>
                            <ChevronRight size={14} />
                        </div>
                    </Link>
                ))}

                {/* Botão de Ação */}
                {/* <button
                    onClick={handleClickOpen}
                    className="flex items-center gap-3 px-4 py-3 w-full rounded-xl text-slate-500 dark:text-gray-300 group transition-all text-left"
                >
                    <span className="w-5 h-5 flex items-center justify-center ">
                        <NotebookPen size={17} className=" group-hover:text-blue5 text-slate-500 "/>
                    </span>
                    <span className="text-start text-sm font-medium group-hover:text-blue5">Liberar Posts</span>
                </button> */}
            </div>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                PaperProps={{
                    style: {
                        borderRadius: '24px',
                        backgroundImage: 'none',
                        maxWidth: '450px',
                        width: '100%',
                        overflow: 'hidden'
                    },
                }}
            >
                {/* Header Estilizado */}
                <div className="bg-gradient-to-r from-blue3 to-blue4 px-6 py-5 border-b border-white/10 shadow-lg">
                    <div className="flex items-center gap-4">
                        <div className="bg-white/10 p-2.5 rounded-xl backdrop-blur-md border border-white/20">
                            <Calendar className="text-white" size={17} />
                        </div>
                        <div>
                            <span className="text-[10px] uppercase font-bold tracking-[0.3em] text-emerald-100/70 block mb-0.5">
                                Configuração de Prazo
                            </span>
                            <h3 className="text-xl font-bold text-white leading-tight">
                                Liberar Publicação
                            </h3>
                        </div>
                    </div>
                </div>

                <DialogContent className="pt-8 pb-4">
                    <div className="flex flex-col gap-6" style={{ fontFamily: 'Montserrat' }}>
                        {/* Input Data Início */}
                        <div className="flex flex-col gap-2">
                            <label className="text-[10px] uppercase font-bold tracking-widest text-slate-400 dark:text-blue-300/50 ml-1">
                                Data de Início
                            </label>
                            <input
                                type="date"
                                value={start}
                                onChange={(e) => setStart(e.target.value)}
                                className="w-full p-3 rounded-xl bg-gray-50 dark:bg-[#061c3f]/50 border border-gray-100 dark:border-white/5 dark:text-white focus:ring-2 focus:ring-blue4/30 outline-none transition-all"
                            />
                        </div>

                        {/* Input Data Término */}
                        <div className="flex flex-col gap-2">
                            <label className="text-[10px] uppercase font-bold tracking-widest text-slate-400 dark:text-blue-300/50 ml-1">
                                Data de Término
                            </label>
                            <input
                                type="date"
                                value={end}
                                onChange={(e) => setEnd(e.target.value)}
                                className="w-full p-3 rounded-xl bg-gray-50 dark:bg-[#061c3f]/50 border border-gray-100 dark:border-white/5 dark:text-white focus:ring-2 focus:ring-blue4/30 outline-none transition-all"
                            />
                        </div>
                    </div>
                </DialogContent>

                <DialogActions className="p-6 pt-2 flex gap-4 border-t border-gray-100">
                    <div className="my-2 w-full flex">
                        <button
                            onClick={handleClose}
                            className="flex-1 h-12 text-xs font-bold text-gray-400 hover:text-red-500 transition-colors tracking-widest uppercase"
                        >
                            Cancelar
                        </button>
                        <button
                            onClick={handlefreePosts}
                            className="flex-[2] h-12 bg-blue3 hover:bg-blue4 text-white text-xs font-bold rounded-xl shadow shadow-blue4/30 transition-all active:scale-95 uppercase tracking-widest"
                        >
                            Salvar Período
                        </button>

                    </div>
                </DialogActions>
            </Dialog>
            <ToastContainer />
        </div>
    )
}